import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { MyNafFrontpageType } from '@appTypes/myNafType';
import { Actions, actions } from '@redux/modules/myNaf';
import { TypedEpic } from './types';

const fetchMyNafFrontpageEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_MYNAF_FRONTPAGE),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getMyNafFrontpage.request>[]
    >,
    switchMap(([action]: { payload: string }[]) =>
      fromApiRequest((signal) =>
        apiClient.get<MyNafFrontpageType>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].mynaf.get(action.payload),
        }),
      ).pipe(
        map((response) => actions.getMyNafFrontpage.success(response.data)),
        catchError((err) => of(actions.getMyNafFrontpage.failure(toReduxError(err, 'Could not get my naf frontpage')))),
      ),
    ),
  );

export const epics: TypedEpic[] = [fetchMyNafFrontpageEpic];
